import React from 'react';
import { Star } from 'lucide-react';

/**
 * SkillStars — compact 0-5 progressive star rating.
 *  - Use `interactive` to allow clicking to set value (`onChange(newValue)`).
 *  - Use `size` for variants: 'sm', 'md', 'lg'.
 */
const SIZES = {
  sm: 'h-3 w-3',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
};

const SkillStars = ({ value = 0, onChange, interactive = false, size = 'md', testIdPrefix }) => {
  const cls = SIZES[size] || SIZES.md;
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  return (
    <div className="flex items-center gap-0.5" data-testid={testIdPrefix ? `${testIdPrefix}-stars` : undefined}>
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = i <= v;
        const Btn = interactive ? 'button' : 'span';
        return (
          <Btn
            key={i}
            type={interactive ? 'button' : undefined}
            onClick={interactive ? () => onChange?.(i === v ? i - 1 : i) : undefined}
            data-testid={interactive && testIdPrefix ? `${testIdPrefix}-star-${i}` : undefined}
            aria-label={interactive ? `Rate ${i} of 5` : undefined}
            className={interactive ? 'transition-transform hover:scale-110 cursor-pointer' : ''}
          >
            <Star
              className={`${cls} ${
                filled
                  ? 'fill-amber-300 text-amber-300 drop-shadow-[0_0_4px_rgba(252,211,77,0.5)]'
                  : 'text-slate-600'
              } transition-all`}
            />
          </Btn>
        );
      })}
    </div>
  );
};

export default SkillStars;
